import { UserTokenService } from '../services/user-token.service';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse, HttpResponse, HttpEvent, HttpResponseBase } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { mergeMap, catchError, tap } from 'rxjs/operators';
 
import { _HttpClient } from './http.client';
import { environment } from 'src/environments/environment';
import { SettingsService } from '../services/settings.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';


const CODEMESSAGE = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
};

/**
 * 默认HTTP拦截器，其注册细节见 `app.module.ts`
 */
@Injectable()
export class GobalHttpInterceptor implements HttpInterceptor {
  constructor(private injector: Injector, private tokenService: UserTokenService, private setting: SettingsService) { }

  get msg(): NzMessageService {
    return this.injector.get(NzMessageService);
  }

  private goTo(url: string) {
    setTimeout(() => this.injector.get(Router).navigateByUrl(url));
  }

  private checkStatus(ev: HttpErrorResponse) {
    if (ev.status >= 200 && ev.status < 300) return;
    let errortext = CODEMESSAGE[ev.status] || ev.statusText;
    let title = "异常错误";

    if (ev instanceof TypeError) {
      errortext = ev.message;
    }
    else if (ev.error instanceof ErrorEvent) {
      errortext = ev.error.message;
    }
    else {
      title = `请求错误 ${ev.status}: ${ev.url}`;
      if (ev.error) {
        this.setting.lastErrorMessage.Message = ev.error.message;
        this.setting.lastErrorMessage.Result = ev.error.result;
      }
    }
    
    this.injector.get(NzNotificationService).error(title, errortext);
  }

  private handleError(error: any) {
    console.error(error);
    this.checkStatus(error);
    this.handleData(error);
    return of(error);
  };
  private handleData(ev: HttpResponseBase): Observable<any> {
    this.injector.get(_HttpClient).end();
    // 业务处理：一些通用操作
    switch (ev.status) {
      case 206:
        break;
      case 201:
        break;
      case 200:
        // 业务层级错误处理，以下是假定restful有一套统一输出格式（指不管成功与否都有相应的数据格式）情况下进行处理
        // 例如响应内容：
        //  错误内容：{ status: 1, msg: '非法参数' }
        //  正确内容：{ status: 0, response: {  } }
        // 则以下代码片断可直接适用
        // if (event instanceof HttpResponse) {
        //     const body: any = event.body;
        //     if (body && body.status !== 0) {
        //         this.msg.error(body.msg);
        //         // 继续抛出错误中断后续所有 Pipe、subscribe 操作，因此：
        //         // this.http.get('/').subscribe() 并不会触发
        //         return throwError({});
        //     } else {
        //         // 重新修改 `body` 内容为 `response` 内容，对于绝大多数场景已经无须再关心业务状态码
        //         return of(new HttpResponse(Object.assign(event, { body: body.response })));
        //         // 或者依然保持完整的格式
        //         return of(event);
        //     }
        // }
        break;
      case 401: // 未登录状态码
        // 请求错误 401: https://preview.pro.ant.design/api/401 用户没有权限（令牌、用户名、密码错误）。
        this.goTo('/passport/login?clean=token');
        break;
      case 403:
      case 404:
      case 500:
        this.goTo(`/exception/${ev.status}`);
        break;
      default:
        if (ev instanceof HttpErrorResponse) {
          console.warn('未可知错误，大部分是由于后端不支持CORS或无效配置引起', ev);
          this.msg.error(ev.message);
        }
        break;
    }
    return of(ev);
  }



  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // 统一加上服务端前缀
    let url = req.url;
    if (!url.startsWith('https://') && !url.startsWith('http://') && url.indexOf('./') < 0) {
       url = environment.SERVER_URL + url;
    }
    const newReq = req.clone({ url, setHeaders: { Authorization: 'Bearer ' + this.tokenService.get() } });
    // return next.handle(newReq).pipe(
    //   tap(
    //     // Succeeds when there is a response; ignore other events
    //     event => {
    //       if (event instanceof HttpResponseBase)
    //         return this.handleData(event);
    //       // 若一切都正常，则后续操作
    //       return of(event);
    //     },
    //     // Operation failed; error is an HttpErrorResponse
    //     error => {

    //       this.handleData(error)
    //     }
    //   ));

    return next.handle(newReq).pipe(
      mergeMap((event: any) => {
        // 允许统一对请求错误处理
        if (event instanceof HttpResponseBase)
          return this.handleData(event);
        // 若一切都正常，则后续操作
        return of(event);
      }),
      catchError((err) => this.handleError(err)),
    );
  }



}
